// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"6064":"87d592b14de4325a0499","7254":"34a742670ec91757ae4d"}[chunkId] + ".js";
};